// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c4ea075f","453":"d69df33a","455":"96798146","977":"551dfe75"}[chunkId] + ".chunk.js";
};